import cms from '@/content';
import treeHelper from './treeHelper';

export default {
    getTextFromValue(value, list) {
        let textEl = list.find(e => e.value === value);
        return textEl ? textEl.text : '';
    },
    getMultipleTextValues(values, list) {
        let texts = values.map(value => {
            let element = list.find(e => e.value === value);
            return element ? element.text : '';
        });

        return texts.filter(el => el).join(';');
    },
    setTextsLogBookElement(e, lang = 'en') {
        e.anatomicAreaText = this.getTextFromValue(e.anatomicArea, cms.orthoDiagnosisNames(lang));
        e.sideText = this.getTextFromValue(e.side, cms.getSides(lang));
        e.priorityText = this.getTextFromValue(e.priority, cms.getPriorities(lang));
        e.sexText = this.getTextFromValue(e.sex, cms.getSexes(lang));

        if (e.specialty === "orl") {
            e.complicationText = this.getTextFromValue(e.complication, cms.getORLComplications(lang));
        }

        if (e.specialty === "orl") {
            e.procedureText = this.getTextFromValue(e.procedure, cms.getORLProcedures(lang));
        }

        if (e.specialty === "orl") {
            e.diagnosisText = this.getTextFromValue(e.diagnosis, cms.getORLProcedures(lang));
        } else if (e.specialty === "ophthalmology") {
            e.diagnosisText = this.getTextFromValue(e.diagnosis, cms.getDiagnoses(lang));
        }

        if (e.treeValues && e.treeValues.length) {
            let procedureBranch = treeHelper.getNode(cms.getTree(), 65);
            let LIOBranch = treeHelper.getNode(cms.getTree(), 66);
            let procedureNoProgBranch = treeHelper.getNode(cms.getTree(), 59);
            let complicationsBranch = treeHelper.getNode(cms.getTree(), 38);

            if (e.specialty === "ophthalmology") {
                e.procedureText = this.getMultipleTextValues(treeHelper.checkIfExist(procedureBranch.children.map(el => el.value), e.treeValues), procedureBranch.children);
            }

            e.LIOText = this.getMultipleTextValues(treeHelper.checkIfExist(LIOBranch.children.map(el => el.value), e.treeValues), LIOBranch.children);
            e.procedureNoProgText = this.getMultipleTextValues(treeHelper.checkIfExist(procedureNoProgBranch.children.map(el => el.value), e.treeValues), procedureNoProgBranch.children);

            if (e.specialty === "ophthalmology") {
                e.complicationText = this.getMultipleTextValues(treeHelper.checkIfExist(complicationsBranch.children.map(el => el.value), e.treeValues), complicationsBranch.children);
            }
        }
        return e;
    },
    setTextsLogBookCollection(entries, lang = 'en') {
        return entries.map(e => this.setTextsLogBookElement(e, lang));
    },
    setTextsSActivityElement(e, lang = 'en') {
        e.typeText = this.getTextFromValue(e.type, cms.getScientificActivitiesTypes(lang));
        e.subTypeText = this.getTextFromValue(e.subType, e.type === 1 ? cms.getScientificActivitiesSubTypesPublication(lang) : cms.getScientificActivitiesSubTypesPresentation(lang));
        e.scopeText = this.getTextFromValue(e.where, cms.getScopesPresentationType(lang));
        return e;
    },
    setTextsSActivityCollection(entries, lang = 'en') {
        return entries.map(e => this.setTextsSActivityElement(e, lang));
    },
    setTextsCoursesElement(e, lang = 'en') {
        e.typeText = this.getTextFromValue(e.type, cms.getCourseTypes(lang));
        return e;
    },
    setTextsCoursesCollection(entries, lang = 'en') {
        return entries.map(e => this.setTextsCoursesElement(e, lang));
    },
}